import React from 'react';

import validateDepth from '../validateDepth';

export const useValidation = ({ initialValues }) => {
  return React.useMemo(
    () => (initialValues ? validateDepth(initialValues) : null),
    [initialValues]
  );
};

export default useValidation;
